<template>
    <div>
        <v-dialog :value="!!activeRideId" lazy @input="activeRideId = null">
            <ride-page v-if="activeRideId" :ride_id="activeRideId"/>
        </v-dialog>

        <v-card>
            <v-card-title>
                <b>Ongoing Rides</b>
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="data" :search="search" :loading="loading">
                <template v-slot:items="props">
                    <tr :class="{
                         'red' : !props.item.avg_speed
                    }">
                        <td class="text-xs-start">{{ props.item.ride_id }}</td>
                        <td class="text-xs-start">{{ props.item.captain_name }}</td>
                        <td class="text-xs-start">{{ props.item.time }}</td>
                        <td class="text-xs-start">{{ props.item.distance }}</td>
                        <td class="text-xs-start">{{ props.item.avg_speed || "N\\A"}}</td>
                        <td class="text-xs-start">{{ props.item.current_speed || "N\\A" }}</td>
                        <td class="text-xs-start">{{ props.item.meter_price | money }}</td>
                        <td class="text-xs-start">{{ props.item.service_name }}</td>
                        <td class="text-xs-start">{{ props.item.start_date }}</td>
                        <td class="text-xs-start">{{ props.item.updated_at }}</td>
                        <td class="text-xs-start">{{ props.item.update_ratio }}</td>
                        <td class="text-xs-start">
                            <v-btn color="primary" @click="() => openRideModal(props.item.ride_id)">Details</v-btn>
                        </td>
                    </tr>
                </template>
                <v-alert v-slot:no-results :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
    import DataTable from "@/components/monaco/DataTable";
    import { toCompanyMoment } from "@/util/companyTime";
    import CarInfo from "@/components/confirmation_captain_components/CarInfo";
    import RidePage from "@/views/RidePage";
    import socketEventsMixin from "@/mixins/socketEventsMixin";

    export default {
        mixins: [socketEventsMixin],
        name: "Ongoing",
        components: {CarInfo, DataTable, RidePage},
        data() {
            return {
                headers: [
                    {text: 'ID', value: 'ride_id'},
                    {text: 'Captain', value: 'captain_name'},
                    {text: 'Time', value: 'time'},
                    {text: 'Distance', value: 'distance'},
                    {text: 'Avg Speed', value: 'avg_speed'},
                    {text: 'Cur Speed', value: 'current_speed'},
                    {text: 'Price', value: 'meter_price'},
                    {text: 'Service', value: 'service_name'},
                    {text: 'Start Date', value: 'start_date'},
                    {text: 'Last Update', value: 'updated_at'},
                    {text: 'Update R.', value: 'update_ratio'},
                    {text: 'Details', value: 'details'}
                ],
                valid: false,
                data: [],
                loading: false,
                search: '',
                services: {},
                activeRideId: null
            };
        },
        beforeDestroy() {
            for (let index in this.data) {
                clearInterval(this.data[index].interval);
                this.data[index].interval = null;
            }
        },
        mounted() {
            this.loading = true;

            this.axios.get('service?with_active_price=true')
                .then(res =>
                    res.data.data.data.forEach(element => {
                        if (element.prices.length > 0) {
                            element.meter_price = element.prices[0];
                        } else {
                            element.meter_price = {};
                        }
                        this.services[element.id] = element;
                    })).catch(err => console.log(err.message));

            this.axios.get('ride/ongoing')
                .then(res => {
                    for (let i = 0; i < res.data.data.length; i++) {
                        res.data.data[i] = this.initElement(res.data.data[i]);
                    }
                    this.data = res.data.data;
                })
                .catch(err => console.log(err.message))
                .finally(() => this.loading = false);

        },
        methods: {
            openRideModal(ride_id) {
                this.activeRideId = ride_id
            },
            distanceUpdated(data) {
                if (!data) return;
                let index = this.data.findIndex((elem => elem.ride_id === data.ride_id));
                if (index > -1) {
                    const time = this.formatTime(this.data[index].start_date, this.moment());
                    const previousDistance = this.data[index].distance;
                    const previousUpdate = this.data[index].updated_at;
                    this.data[index].distance = this.round(data.distance, 2);
                    // Final-version doc 2026-10-05: stamps are company wall
                    // time (UTC+3) and every diff reads them as such, so a
                    // PC in another zone does not skew speeds by an hour.
                    this.data[index].updated_at = this.$companyTime(this.moment(), 'YYYY-MM-DD HH:mm:ss');
                    this.data[index].current_speed = ((this.data[index].distance - previousDistance) /
                        this.hoursBetween(previousUpdate, this.data[index].updated_at)).toFixed(2);

                    this.data[index].avg_speed = (this.data[index].distance /
                        this.hoursBetween(this.data[index].start_date, this.data[index].updated_at)).toFixed(2);
                    this.data[index].route_length++;
                    this.data[index].update_ratio = this.updateRatio(this.data[index].route_length, time.seconds);
                }
            },
            pickedUp(data) {
                this.data.push(this.initElement(data));
            },
            done(data) {
                let index = this.data.findIndex((elem => elem.ride_id === data.ride_id));
                if (index > -1) {
                    this.data[index].km_count = this.data[index].distance;
                    this.data[index].elapsed_time = this.data[index].time;
                    this.data[index].waiting_time = 0;
                    this.$emit('done', this.data[index]);
                    clearInterval(this.data[index].interval);
                    this.data.splice(index, 1);
                }
            },
            round(val, point_cnt = 2) {
                return Math.round((val) * Math.pow(10, point_cnt)) / Math.pow(10, point_cnt)
            },
            hoursBetween(from, to) {
                const fromAt = toCompanyMoment(from);
                const toAt = toCompanyMoment(to);
                return fromAt && toAt ? toAt.diff(fromAt, 'hour', true) : NaN;
            },
            formatTime(start, end) {
                const hours = this.hoursBetween(start, end);
                const minutes = hours * 60;
                const seconds = minutes * 60;
                return {
                    hours: hours,
                    minutes: minutes,
                    seconds: seconds,
                    formatted: (Math.floor(hours) > 9 ? Math.floor(hours) : '0' + Math.floor(hours)) + ':' +
                        (Math.floor(minutes - Math.floor(hours) * 60) > 9 ? Math.floor(minutes - Math.floor(hours) * 60) : '0' + Math.floor(minutes - Math.floor(hours) * 60)) + ':' +
                        (Math.floor(seconds - Math.floor(minutes) * 60) > 9 ? Math.floor(seconds - Math.floor(minutes) * 60) : '0' + Math.floor(seconds - Math.floor(minutes) * 60))
                };
            },
            updateRatio(updates_count, elapsed_time_in_seconds) {
                if (Math.floor(elapsed_time_in_seconds) > 0) {
                    return this.round(100 * updates_count / (elapsed_time_in_seconds / 10), 0) + '%';
                }
                return 'INFINITY';
            },
            getMeterPrice(service_id, time, distance) {
                return this.services[service_id].meter_price.base_fare +
                    this.services[service_id].meter_price.booking_cost_per_min * time +
                    this.services[service_id].meter_price.booking_cost_per_km * distance;
            },
            initElement(element) {
                const time = this.formatTime(element.start_date, this.moment());
                element.distance = this.round(element.distance);
                element.time = time.formatted;
                element.update_ratio = this.updateRatio(element.route.length, time.seconds);
                element.route_length = element.route.length;
                element.meter_price = this.round(this.getMeterPrice(element.service_id, time.minutes, element.distance), 2);
                element.service_name = this.services[element.service_id].name;
                element.interval = setInterval(() => {
                    const time = this.formatTime(element.start_date, this.moment());
                    element.time = time.formatted;
                    element.meter_price = this.round(this.getMeterPrice(element.service_id, time.minutes, element.distance), 2);
                }, 1000);
                return element;
            }
        },
        events() {
            return {
                'Ride:new_booking_picked_up': this.pickedUp,
                'Ride:new_booking_done': this.done,
                'distance_updated': this.distanceUpdated
            }
        }
    }
</script>

<style scoped>

</style>